import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent, DialogActions, Button, DialogContentText } from '@mui/material';

import OperationForm from './OperationForm';

export default function ConfSetPdpPco(props, context) {
  const [open, setOpen] = useState(false);
  const [selectedValues, setSelectedValues] = useState({ setPdp: null, setPco: null });

  const handleClose = () => {
    setOpen(false);
    setSelectedValues({ setPdp: null, setPco: null });
  };

  const handleSubmit = () => {
    if (selectedValues.setPdp !== null) {
      props.updatePdpConfig({ setPdp: selectedValues.setPdp , setPco: selectedValues.setPco });
    }
    handleClose();
  };

  const getPdpLabel = (value) => {
    if (!value || !props.pdpFields?.[0]?.options) return '';
    const option = props.pdpFields[0].options.find(opt => opt.optionKey === parseInt(value, 10));
    return option?.label || '';
  };

  const getPcoLabel = (value) => {
    if (!value || !props.pcoFields?.[0]?.options) return '';
    const option = props.pcoFields[0].options.find(opt => opt.optionKey === parseInt(value, 10));
    return option?.label || '';
  };

  // Combine PDP and PCO fields into a single array
  const combinedFields = [...(props.pdpFields || []), ...(props.pcoFields || [])];

  return (
    <>
      <OperationForm
        enable={props.enable}
        fields={combinedFields}
        onSubmit={(params) => {
          setSelectedValues({
            setPdp: params.setPdp,
            setPco: params.setPco
          });
          setOpen(true);
        }}
      />

      <Dialog open={open} onClose={handleClose} maxWidth="sm">
        <DialogContent>
          <DialogContentText style={{fontSize: 'large', color: 'black', textAlign: 'center'}}>
            {context.t('you_are_about_to_take_a_significant_action_on_num_devices', { num: props.countSelected })}<br/>
            {selectedValues.setPdp && (
              <span style={{fontSize: 'medium', color: '#606060', display: 'block'}}>
                {context.t('confirm_updating_devices_pdp_to', { pdp: getPdpLabel(selectedValues.setPdp) })}
              </span>
            )}
            {selectedValues.setPco && (
              <span style={{fontSize: 'medium', color: '#606060', display: 'block'}}>
                {context.t('confirm_updating_devices_pco_to', { pco: getPcoLabel(selectedValues.setPco) })}
              </span>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">{context.t('cancel')}</Button>
          <Button onClick={handleSubmit} color="primary" autoFocus>{context.t('confirm')}</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

ConfSetPdpPco.propTypes = {
  enable: PropTypes.bool,
  countSelected: PropTypes.number,
  pdpFields: PropTypes.array,
  pcoFields: PropTypes.array,
  updatePdpConfig: PropTypes.func.isRequired,
  updatePcoConfig: PropTypes.func.isRequired,
};

ConfSetPdpPco.defaultProps = {
  enable: false,
  countSelected: 0,
  pdpFields: [],
  pcoFields: [],
};

ConfSetPdpPco.contextTypes = {
  t: PropTypes.func.isRequired,
}; 